import { generateClientErrorMessage } from "../utils/generateClientErrorMessage"
import { api } from "../config/api"

// Registro dos cadastros da LP /agrega+gh na planilha do cliente (API do blog: POST /registeragregagh).
// O e-mail continua saindo pelo EmailSender (sendContactEmail2).
export const registerAgregaGh = async (body) => {
    try {
        const res = await api.post('/registeragregagh', body)

        if (res.status !== 200) {
            // O interceptor da api devolve o erro em vez de lançar: o status HTTP fica em res.response.
            return { success: false, status: res.response?.status, message: generateClientErrorMessage(res) }
        }

        return { success: true, data: res.data.data }

    } catch (error) {
        console.error(error)
        return { success: false, status: error.response?.status, message: generateClientErrorMessage(error) }
    }
}
